import { getSessionToken } from "./clerk";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

/**
 * Ask our own server for permission to upload to Cloudinary.
 *
 * Uploads used to go straight to Cloudinary with an unsigned preset, and the
 * preset's name had to ship in this JavaScript, so anyone who read it could
 * upload into the family's account. Now the server holds the secret and signs
 * each batch of uploads for a signed-in member (POST /api/uploads/signature).
 * A signature stays valid for one hour, so one is enough for a whole selection.
 *
 * Throws with a plain message when the server will not sign.
 */
export async function getUploadSignature() {
  const token = await getSessionToken();
  const response = await fetch(`${API_URL}/uploads/signature`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  let body = {};
  try {
    body = await response.json();
  } catch {
    body = {};
  }
  if (!response.ok || !body.signature) {
    throw new Error(body.error || "Uploads aren’t available right now.");
  }
  return body;
}
